import { Component, Inject, Input } from '@angular/core';
import { AccountTicketsNgrxFacade } from '../../../account-tickets-ngrx';
import { TicketActivateSameValidityConfirmationComponent } from '../ticket-activate-same-validity-confirmation/ticket-activate-same-validity-confirmation.component';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ridango-ticket-activate-confirmation-modal',
    templateUrl: './ticket-activate-confirmation.component.html',
    styleUrls: ['./ticket-activate-confirmation-modal.component.scss']
})
export class TicketActivateConfirmationComponent {
    @Input() data: { docNum: string };
    @Input() callback?: () => void;
    constructor(
        private ticketsFacade: AccountTicketsNgrxFacade,
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env,
        private translate: TranslateService
    ) {}

    async confirmActivation() {
        const docNum = this.data.docNum;
        if (this.env.TICKET?.MANUAL_ACTIVATION_CHECK_VALIDITY) {
            this.ticketsFacade.preActivateTicketCheck(this.data.docNum).subscribe(async (result) => {
                const sameValidityFound = !result.checkPassed;

                if (sameValidityFound) {
                    const modal = await this.modalCtrl.create({
                        component: TicketActivateSameValidityConfirmationComponent,
                        cssClass: 'ticket-activate-same-validity-confirmation-modal',
                        componentProps: { data: { docNum } }
                    });

                    this.close();
                    await modal.present();

                    const title = modal.querySelector<HTMLElement>('[data-modal-title]');
                    if (title) {
                        title.focus();
                    }

                    const { data: result } = await modal.onWillDismiss<boolean>();
                    if (result === true) {
                        this.ticketsFacade.activateTicket(docNum);
                        this.callback?.();
                    } else {
                        this.close(false);
                    }
                } else {
                    this.ticketsFacade.activateTicket(this.data.docNum);
                    this.close(true);
                }
            });
        } else {
            this.ticketsFacade.activateTicket(docNum);
            this.close(true);
            this.callback?.();
        }
    }

    close(success: boolean | null = null) {
        this.modalCtrl.dismiss(success, 'close');
    }

    cancel() {
        this.close(false);
    }
}
